import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, PaletteLinearProgress, Paper, TextField } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import api from "../../../API";
import SampleListPage from "../../sample/dialog/SampleListPage";
import { useSelector } from "react-redux";
import ScriptFileListPage from "./ScriptFileListPage";

interface IFileTypes {
  id: number;
  object: File;
}

interface UploadResult {
  fileName: string;
  state: string;
}

const ScriptUploadPage = (props:any) => {


  const [jumin_1, setJumin_1] = useState("");
  const [jumin_2, setJumin_2] = useState("");

  const [bank, setbank] = useState("");
  const [accountnumber, setaccountnumber] = useState("");

  const [jumin, setJumin] = useState("");
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [files, setFiles] = useState<IFileTypes[]>([]);
  const [uploadResult , setUploadResult] = useState<UploadResult[]>([]);

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  

  const fileUpload = async () => {

    // if(jumin_1.length < 6){
    //   alert('주민번호 앞자리를 확인하여주세요')
    //   return;
    // }

    // if(jumin_2.length < 7){
    //   alert('주민번호 뒷자리를 확인하여주세요')
    //   return;
    // }

    // // console.log('주민번호', jumin)

    // if (files.length === 0) {
    //   alert("통장사본[이미지] 업로드할 파일을 선택해주세요.");
    //   return;
    // }

    const formData = new FormData();
    // 선택한 파일들을 formData에 추가
    const file_data:any = {};

    let xlsx_cnt = 0;
    let photo_cnt = 0;

    files.forEach((file) => {
      console.log('업로드할 파일' , file.object)
      const extension = file.object.name.split(".").pop();
      console.log('extension', extension)
      
      if(extension && ["xlsx","xls","xlsb","xlsm"].includes(extension.toLowerCase())){
        formData.append("xlsx", file.object.name);
        xlsx_cnt +=1;
      }
      // else if(extension && ["png","jpg","jpeg"].includes(extension.toLowerCase())){
      //   formData.append("photo", file.object.name);
      //   photo_cnt +=1;
      // }
      // else{
      //   alert(file.object.name + ' 확장자를 확인하여주세요.')
      //   return;
      // }
      formData.append("files", file.object);

    });

    if(xlsx_cnt < 1){
      alert('스크립트 파일 1개 이상을 업로드 해주세요.')
      return;
    }

    // if(photo_cnt != 1){
    //   alert('통장사본(이미지) 1개 파일을 업로드 해주세요.')
    //   return;
    // }


    // formData.append("sample_idx", sample_idx)
    // formData.append("jumin", jumin)
    // formData.append("bank", bank)
    // formData.append("bank_num",accountnumber)
    formData.append("email",email)

    // console.log('은행명', bank, 'bank_num', accountnumber)

    // let difference = ["mp3","mp4","wav","ogg","m4a","aac","srt","txt","png","jpg","jpeg"].filter(x => file_extension.includes(x)); 
    

    // if(difference.length < 3){
    //   alert('1. 음성파일, 2.텍스트파일, 3.사진파일 총 3개 파일을 업로드하여야 합니다.')
    //   return;
    // }

    // return;
      
    setBackdrop(true)
    const result = await api.post("/uploadScript", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then((res:any) => {
      setBackdrop(false); 
      console.log("file upload ", res.data.datas); 
      setUploadResult(res.data.datas); 
      setFiles([]);
      alert('업로드 처리가 끝났습니다. 결과를 꼭 확인하여 주세요.')
      props.getAuth();
      setSearchScriptFileList(true);
    })
    // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {
      setBackdrop(false); 
      // var res = JSON.parse(error.response.data);
      console.error('업로드 오류'); 
      alert('스크립트 파일 업로드에 실패하였습니다.')
      // alert(res['fileName'] + ' 파일은 이미 업로드 되어있습니다. [상태 : ' + res['state'] + ']')
    })
    // alert("파일 업로드 실패. " + error.response.data.error);
      
  };

  const onChangeFiles = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any): void => {
      let selectFiles: File[] = [];
      let tempFiles: IFileTypes[] = files;
  
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }
  
      for (const file of selectFiles) {
        const extension = file.name.split(".").pop();
  
        // 파일업로드 확장자 통과목록

        // if (extension === "mp3" || extension === "wav" || extension === "ogg" || extension === "m4a" || extension === "M4A") {

        const isDuplicate = tempFiles.some(
          (tempFile) =>
            tempFile.object.name === file.name
        );
        if (isDuplicate) {
          alert(`${file.name} 파일은 이미 추가되었습니다.`);
        } else if (
          extension &&
          ["xlsx","xls","xlsb","xlsm"].includes(extension.toLowerCase())
        ) {
        tempFiles = [
          ...tempFiles,
          {
            id: fileId.current++,
            object: file,
          },
        ];
        } else {
          // alert("오디오 파일만 업로드 가능합니다.");
          alert("업로드가 불가한 파일 확장자를 포함합니다. 다시확인하여 주세요.");
        }
      }
      // console.log("tempFiles", tempFiles);
      setFiles(tempFiles);
    },
    [files]
  );

  const handleFilterFile = useCallback(
    (id: number): void => {
      setFiles(files.filter((file: IFileTypes) => file.id !== id));
    },
    [files]
  );

  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer!.files && e.dataTransfer!.files.length > 0) {
      const extension = e.dataTransfer!.files[0].name.split(".").pop();
      if (extension && ["xlsx","xls","xlsb","xlsm"].includes(extension.toLowerCase())
      ) {
        setIsDragging(true);
      } else {
        setIsDragging(false);
      }
    }
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      onChangeFiles(e);
      setIsDragging(false);
    },
    [onChangeFiles]
  );

  const initDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);


  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // const [scriptFileUploadList, setScriptFileUploadList] = useState([]);
  
  // const scriptFileUploadListByUser = async () => {
  //   const result = await api.get("/scriptFileUploadListByUser",{params:{worker:email}})
  //   .then((res:any) => {console.log("문서요청 리스트 ", res.data.datas); setScriptFileUploadList(res.data.datas); })
  //   // alert("파일 업로드가 완료되었습니다.");
  //   .catch((error:any) => {console.error('에러',error.response);})
  //   // alert("파일 업로드 실패. " + error.response.data.error);
  // }

  const [searchScriptFileList , setSearchScriptFileList] = useState<boolean>(false);


  useEffect(() => {
    // scriptFileUploadListByUser();
    initDragEvents();
    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);


  return (
        <React.Fragment>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdrop} >
            <CircularProgress color="inherit" /> UPLOADING...
          </Backdrop>

          {/* <SampleListPage samples={samples} /> */}
          {/* <Box>
            {(documentFiles.length > 0) ? <DocumentListPage documentFiles={documentFiles} /> : <></> }
          </Box> */}
          <Box display="flex">
            <Paper sx={{ marginTop: "-56px", width:"900px", marginRight:"16px", borderTop: "4px solid #3e36a5"}}>
              <ScriptFileListPage searchScriptFileList={searchScriptFileList} setSearchScriptFileList={setSearchScriptFileList} />
            </Paper>
            
            <Paper sx={{ marginTop: "-56px", padding: "56px", borderTop: "4px solid #3e36a5", width:"600px"}}>
              <Box sx={{padding:"20px 8px 8px 8px"}}>
                <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "32px", letterSpacing:"-2px",marginTop:"-40px"}}>스크립트 파일 제출</Box>
                <hr style={{borderTop : "2px solid #3e36a5", marginTop:"px"}}></hr>
                
                <div className="DragDrop">
                <input
                  type="file"
                  id="fileUpload"
                  style={{ display: "none" }}
                  multiple={true}
                  onChange={onChangeFiles}
                />

                <label
                  className={isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}
                  htmlFor="fileUpload"
                  ref={dragRef}
                  style={{width: "100%"}}
                >
                  <Box>파일 첨부</Box>
                </label>
                
                <div className="DragDrop-Files">
                  {files.length > 0 &&
                    files.map((file: IFileTypes) => {
                      const {
                        id,
                        object: { name },
                      } = file;

                      return (
                        <div key={id}>
                          <div>{name}</div>
                          <div
                            className="DragDrop-Files-Filter"
                            onClick={() => handleFilterFile(id)}
                          >
                            <CancelIcon fontSize="small" />
                          </div>
                        </div>
                      );
                    })}
                </div>
                {(uploadResult.length > 0) && (files.length === 0) ? 
                  (<React.Fragment>
                    <Box sx={{fontSize:"20px", fontWeight:600}}>스크립트 업로드 결과</Box>
                    {uploadResult.map((result:UploadResult) => 
                      <Box display="flex" sx={{padding:2}} key={result.fileName}>
                        <Box sx={{fontWeight:600}}>{result.fileName}</Box>
                        {result.state == "성공" ? 
                          <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                          : 
                          <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                      </Box>
                    )}
                  </React.Fragment>)
                : ""}
                <Box sx={{display:"flex" , justifyContent: "end"}}>
                  <Button sx={{width: "230px", fontWeight: 600, backgroundColor: "#9f9f9f", color: "#fff"}} variant="contained" onClick={fileUpload}>파일 업로드</Button>
                </Box>
              </div>
              </Box>
              <Box sx={{fontWeight:600, marginLeft:2}}>
                <Box color="blue">스크립트를 작성한 엑셀 파일을 업로드해주세요 {<b style={{color:"red"}}>(한셀X)</b>}</Box>
                <Box color="blue">생성한 엑셀파일명은 해당 위키백과 문서제목과 일치해야합니다.</Box>
                {/* <Box color="blue">{"("}<b style={{color:"red"}}>통장사본</b>{")"} , 계약서 - {"("} <b style={{color:"red"}}>음성 이용 동의서, 보안서약서, 개인정보 이용 동의서</b>{")"}</Box> */}
                <Box color="black">업로드 처리 후 업로드 결과를 확인해주세요.</Box>
                <Box color="black">업로드에 문제가 있는 경우 관리자에게 연락바랍니다.</Box>
                
              </Box>
            </Paper>
          </Box>
        </React.Fragment>
  );
};

export default ScriptUploadPage;
